import { composeIO } from 'react-compose-io'
import { cardComissaoIO } from './CardComissao.IO'
import { CardComissaoView } from './CardComissao.View'

export const CardComissao = composeIO(CardComissaoView, cardComissaoIO)
